export const heroArchitectureNodes = [
  { id: "client", title: "Client", subtitle: "Web · Dashboard · Mobile" },
  { id: "api", title: "API Gateway", subtitle: "Auth · Routing · Rules" },
  { id: "core", title: "Core App", subtitle: "Logic · Services" },
  { id: "ai", title: "AI Workflow", subtitle: "Assistant · Automation" },
  { id: "data", title: "Data Layer", subtitle: "DB · Storage · Vector" },
  { id: "integrations", title: "Integrations", subtitle: "CRM · IoT · Webhook" },
  { id: "deploy", title: "Deploy & Monitor", subtitle: "CI/CD · Logs · Metrics" },
];
